var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "doc_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DA552F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D04B25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#doc_svg__a)",
    d: "M128 256c70.694 0 128-57.306 128-128S198.694 0 128 0 0 57.306 0 128s57.306 128 128 128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96 76.8v102.4h19.2v-32h29.056c19.296-.512 34.944-16.16 34.944-35.2 0-19.552-15.648-35.2-34.944-35.2H96Zm48.493 51.2H115.2V96h29.293c8.563 0 15.507 7.168 15.507 16s-6.944 16-15.507 16Z"
  }))));
};
export { SvgDoc as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCAyNTYgMjU2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KICAgIDxkZWZzPg0KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxvZ29zUHJvZHVjdGh1bnQwIiB4MT0iNTAlIiB4Mj0iNTAlIiB5MT0iMCUiIHkyPSIxMDAlIj4NCiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNEQTU1MkYiLz4NCiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI0QwNEIyNSIvPg0KICAgICAgICA8L2xpbmVhckdyYWRpZW50Pg0KICAgIDwvZGVmcz4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8cGF0aCBmaWxsPSJ1cmwoI2xvZ29zUHJvZHVjdGh1bnQwKSIgZD0iTTEyOCAyNTZjNzAuNjk0IDAgMTI4LTU3LjMwNiAxMjgtMTI4UzE5OC42OTQgMCAxMjggMFMwIDU3LjMwNiAwIDEyOHM1Ny4zMDYgMTI4IDEyOCAxMjhaIi8+DQogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik05NiA3Ni44djEwMi40aDE5LjJ2LTMyaDI5LjA1NmMxOS4yOTYtLjUxMiAzNC45NDQtMTYuMTYgMzQuOTQ0LTM1LjJjMC0xOS41NTItMTUuNjQ4LTM1LjItMzQuOTQ0LTM1LjJIOTZabTQ4LjQ5MyA1MS4ySDExNS4yVjk2aDI5LjI5M2M4LjU2MyAwIDE1LjUwNyA3LjE2OCAxNS41MDcgMTZzLTYuOTQ0IDE2LTE1LjUwNyAxNloiLz4NCiAgICA8L2c+DQo8L3N2Zz4=";